var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconProductionControl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "64 64 896 896",
    focusable: "false",
    "data-icon": "press",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-icon_productionControl"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_productionControl",
    clipPath: "url(#clip-icon_productionControl)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M848,120a56.064,56.064,0,0,1,56,56V848a56.064,56.064,0,0,1-56,56H176a56.064,56.064,0,0,1-56-56V176a56.064,56.064,0,0,1,56-56H848m0-56H176A112,112,0,0,0,64,176V848A112,112,0,0,0,176,960H848A112,112,0,0,0,960,848V176A112,112,0,0,0,848,64Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M801.215,353.44a35.634,35.634,0,0,1-35.637,35.637h-318.7a10.178,10.178,0,0,0-10.182,10.181v46.4a35.636,35.636,0,1,1-71.273,0v-46.4a10.187,10.187,0,0,0-10.182-10.181H262.545a35.637,35.637,0,1,1,0-71.273h92.693a10.188,10.188,0,0,0,10.182-10.182V264.986a35.636,35.636,0,1,1,71.273,0v42.636A10.179,10.179,0,0,0,446.875,317.8h318.7A35.643,35.643,0,0,1,801.215,353.44Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M227.061,674.277A35.632,35.632,0,0,0,262.7,709.914H581.4A10.179,10.179,0,0,1,591.583,720.1v46.4a35.636,35.636,0,1,0,71.272,0V720.1a10.187,10.187,0,0,1,10.182-10.182H765.73a35.637,35.637,0,1,0,0-71.273H673.037a10.187,10.187,0,0,1-10.182-10.182V585.823a35.636,35.636,0,1,0-71.272,0v42.636A10.179,10.179,0,0,1,581.4,638.641H262.7A35.643,35.643,0,0,0,227.061,674.277Z",
    fill: "currentColor"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProductionControl);
export default __webpack_public_path__ + "static/media/icon-productionControl.7be768545bf232c758c4456437d3cec3.svg";
export { ForwardRef as ReactComponent };